module.exports = __webpack_public_path__ + "images/emoji/tokyo_tower.9c7cae2d3a52c4e5355b.png";